import type { QueryClient } from "@tanstack/react-query";

// VP-94: arkusz ofertowy (ICP) jest czytany przez kilka różnych kluczy React Query
// w zależnych od siebie miejscach (dropdown arkuszy solo, podgląd arkusza klienta
// agencyjnego, picker arkuszy przy kliencie). Każda ścieżka zapisu/podpięcia arkusza
// musi unieważnić KOMPLET tych kluczy — inaczej świeżo zapisany arkusz nie pojawia się
// na liście / nie da się go wybrać aż do pełnego odświeżenia strony.
//
// Klucze odczytu:
//   ['/api/offer-sheets']            — dropdown arkuszy (solo) w chat-interface
//   ['/api/offer-sheets/active']     — aktywny arkusz (badge / ad-graphics)
//   ['offer-sheets-picker']          — picker arkuszy przy kliencie (client-selector)
//   ['client-offer-sheet', clientId] — arkusz podpięty do wybranego klienta (agencja)
export function invalidateOfferSheetCaches(qc: QueryClient, clientId?: string | null): void {
  qc.invalidateQueries({ queryKey: ["/api/offer-sheets"] });
  qc.invalidateQueries({ queryKey: ["/api/offer-sheets/active"] });
  qc.invalidateQueries({ queryKey: ["offer-sheets-picker"] });
  if (clientId && clientId !== "none") {
    qc.invalidateQueries({ queryKey: ["client-offer-sheet", clientId] });
  }
}
